<template>
<div>
  <van-nav-bar
      title="活动中心"
      left-text=""
      left-arrow
      @click-left="onClickLeft()"
    >
  </van-nav-bar>
  <div style="height:100%">
    <van-notice-bar 
      left-icon="volume-o" scrollable
      :text="rankText" style="height:25px;" color="red" background="rgba(R,G,B,A)"/>
    <img src="../assets/contract_bg.jpg" fit="contain" width="100%" style="opacity: 1;">
    <div style="margin-top:-28%;text-align:center;">
      <van-button round plain hairline type="danger" style="width:140px;height:30px;" @click="contract" v-if="isContract==0">确认签约</van-button>
      <van-button round plain hairline type="danger" style="width:140px;height:30px;" v-else>已签约</van-button>
    </div>
    
  </div>
  
</div>
  
</template>
<script>
import { Button, NavBar, NoticeBar} from "vant";
export default {
  data() {
    return {
      rankText: "",
      isContract: 0
    };
  },
  created() {
    this.QueryContract();
    this.QueryTop20();
  },
  methods: {
    contract() {
      var that = this;
      that.$http.get("Activity/GetUserContract", {
          params: {},
        }).then((res) => {
          if (res.data == "success") {
            that.$toast("签约成功！");
            that.QueryContract();  
            that.QueryTop20();         
          } else {
            that.$toast(res.data);
          }
        });
    },
    QueryTop20() {
      var that = this;
      that.$http.get("Activity/QueryTop20Year", {
          params: {},
        }).then((res) => {
          if (res.data.Msg == "success") 
          {
            that.rankText=res.data.Data.Text;  
          } else {
            that.$toast(res.data);
          }
        });
    },
    QueryContract() {
      var that = this;
      that.$http.get("Activity/QueryContract", {
          params: {},
        }).then((res) => {
          if (res.data.Msg == "success") 
          {
            that.isContract=res.data.Data.IsContract;  
          } else {
            that.$toast(res.data);
          }
        });
    },
    onClickLeft() {
      this.$router.back(-1);
    },
  },
  components: {
    [Button.name]: Button,
    [NoticeBar.name]: NoticeBar,
    [NavBar.name]: NavBar,
  },
};
</script>
<style scoped>
</style>
